module.exports = __webpack_public_path__ + "static/img/C.3a9d495.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/C.jpg
// module id = 14
// module chunks = 0